import React from 'react';
import '../styles/ownerMsg.css'; // Optional: extract styles here later if needed

const OwnerMsg = () => {
  return (
    <section className="section bg-white owner-message">
      <div className="section-inner">
        <div className="owner-content">
          <div className="owner-image">
            <img 
              src="/images/matt_Taylor.jpeg"
              alt="Matthew Taylor, Owner" 
            />
          </div>
          <div className="owner-text">
            <h2>A Message from Our Owner</h2>
            <p className="owner-intro">Matthew Taylor, Owner & President</p>
            <blockquote>
              "When I took over All Seasons, I made a promise to uphold the legacy of excellence 
              that this company was built on. Every testimonial you read here represents not just 
              a completed project, but a relationship we've cultivated with care."
            </blockquote>
            <p>
              Our team doesn't just maintain landscapes – we become stewards of your outdoor spaces. 
              We understand that your property is more than an investment; it's where memories are made, 
              where you find peace, and where you connect with Idaho's natural beauty.
            </p>
            <p>
              These testimonials reflect our commitment to treating every property as if it were our own. 
              Thank you for trusting us with your landscapes for over three decades.
            </p>
            <div className="owner-signature">
              <img 
                src="/images/mTaylorSig.png" 
                alt="Matthew Taylor Signature" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OwnerMsg;
